<template>
    <div class="wrap">
      
        <div class="container">
            <img class="back1" style="height: 28px; margin: 10px 0 10px 15px;"  @click="$router.back()"  src="../images/fanhui1.png" mode="heightFix" alt="">
            <div class="help_title">
                <p>{{article.title}}</p>
                <p></p>
            </div>
            <van-divider :style="{ borderColor: '#eee', margin: '0' }"></van-divider>
            <div class="help" v-html="article.content">
				
				
			</div>
        </div>
        <v-foot></v-foot>
    </div>
</template>
<style scoped>
.back1{
    /* height: 10px; */
    /* margin-left: 25px; */
    margin: 10px 0 10px 25px;
  }
</style>
<script>
	var _this;
    // @ is an alias to /src
    export default {
        components: {},
		created() {
			_this = this;
			this.aid = this.$route.query.id;
           
			this.getData(this.aid);
            this.getjiant()

		},
        watch: {
            $route: {
                handler() {
                    this.aid = this.$route.query.id;
                    this.getData(this.aid);
                    //深度监听，同时也可监听到param参数变化
                },
                deep: true,
            }
        },
		
        data() {
			return {
				"aid":0,
				"article":[],			
			}
        },
        methods: {
            getjiant(){
                this.GET("api/agreement/maidian?type=help", function (data) {
                if (data.code == 0) {
                    console.log(data);
                }
                });
            },
			getData(id){
                console.log('this.aid',id);
				this.POST("api/article/index",{"id":id},function(d){
					// window.console.log(d);
					if(d.code == 0){
						_this.article = d.data;
					}else{
						_this.$toast(d.msg);
					}
				});
			},
        },
    }
</script>